export const COLOR_DEFAULT = "#008080";
export const COLOR_ALARM = "#ff6347";
export const API_URL = "https://alerts.com.ua/api";
export const API_KEY = "cfc9ed5cfa5a7ab0dd10fb73e82d3a701a7b1256"